import React from 'react'
import PropTypes from 'prop-types'
import globals from '../globals'

const SubHeader = (props) => {
    return (
        <div className={`d-flex align-items-center ${props.className}`}>
            {props.icon
                ? <img src={`/images/${props.icon}`} alt='Icon' height='80px' className='mr-5 d-none d-lg-inline-block' />
                : ''}
            <div>
                <p
                    className={`m-0 text-center ${props.icon ? 'text-lg-left' : ''} lh`}
                    dangerouslySetInnerHTML={{ __html: globals.noWidows(props.content) }}
                />
            </div>
        </div>
    )
}

SubHeader.propTypes = {
    icon: PropTypes.string,
    content: PropTypes.string.isRequired,
    className: PropTypes.string
}

SubHeader.defaultProps = {
    className: ''
}

export default SubHeader



// WEBPACK FOOTER //
// ./resources/js/components/SubHeader.js